import { StatusBadge } from '../../../common/StatusBadge/StatusBadge';
import './InterferenceResultView.css';

export const InterferenceResultView = ({ result }) => {
    const { violations, scanned_models: scannedModels } = result;
    const hasViolations = violations.length > 0;

    return (
        <details className="irv-details">
            <summary>
                <StatusBadge
                    label={`${violations.length} violation${violations.length === 1 ? '' : 's'}`}
                    variant={hasViolations ? 'danger' : 'success'}
                />
            </summary>

            <div className="irv-body">
                {hasViolations && (
                    <table className="rules-table">
                        <thead>
                            <tr>
                                <th className="rules-th">First element</th>
                                <th className="rules-th">Second element</th>
                            </tr>
                        </thead>
                        <tbody>
                            {violations.map((violation, index) => (
                                <tr key={index} className="rules-tr">
                                    <td className="rules-td irv-global-id">{violation.first_global_id}</td>
                                    <td className="rules-td irv-global-id">{violation.second_global_id}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

                {scannedModels.length > 0 && (
                    <div className="irv-scanned-models">
                        <h4 className="irv-scanned-models-title">Scanned models</h4>
                        <ul>
                            {scannedModels.map((model) => (
                                <li key={model.project_model_object_id} className="irv-global-id">
                                    {model.project_model_object_id} (v{model.version})
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </details>
    );
};

export default InterferenceResultView;
